import axios from 'axios';

export async function resolveIP(ip) {
  try {
    let urlEnd = `https://ipapi.co/${ip}/json/`;
	let cntr = null;
	let lttd = null;
	let lngtd = null;
	axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';  
    const [geoRes] = await Promise.all([
	  axios.get(`https://radioital.com/api/public/api/site/geo/${ip}`)
    ]);
	console.log(geoRes)
    if (geoRes?.data.lat || !geoRes?.data.lon || !geoRes?.data.countryCode){
		cntr = geoRes.data.countryCode;
		lttd = geoRes.data.lat;
		lngtd = geoRes.data.lon;
	}
	
	if( cntr == null || lttd == null || lngtd == null ) return null; 

    return {
      ip,
      country: cntr,
      lat: lttd,
      lng: lngtd
    };
  } catch {
    return null;
  }
}